/**
 * EM Product Video Bubble — open modal from gallery overlay bubble
 */
(() => {
  if (customElements.get("em-product-video-bubble")) return;

  class EmProductVideoBubble extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector("[data-em-vb-modal]");
      this.player = this.querySelector("[data-em-vb-player]");
      if (!this.modal || !this.player) return;

      // Avoid clipping / z-index issues inside gallery
      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal);
      }

      this.addEventListener("click", this.#onClick);
      document.addEventListener("keydown", this.#onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.#onClick);
      document.removeEventListener("keydown", this.#onKeydown);
    }

    #onClick = (event) => {
      if (event.target.closest("[data-em-vb-open]")) {
        event.preventDefault();
        this.#open();
        return;
      }
      if (event.target.closest("[data-em-vb-close]")) {
        event.preventDefault();
        this.#close();
      }
    };

    #onKeydown = (event) => {
      if (event.key === "Escape" && this.modal.classList.contains("is-open")) {
        this.#close();
      }
    };

    #open() {
      this.modal.hidden = false;
      this.modal.classList.add("is-open");
      try {
        this.player.currentTime = 0;
      } catch (e) {}
      const playPromise = this.player.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    }

    #close() {
      this.modal.classList.remove("is-open");
      this.modal.hidden = true;
      this.player.pause();
    }
  }

  // Close clicks on body-moved modal (outside host)
  document.addEventListener("click", (event) => {
    const closeEl = event.target.closest("[data-em-vb-close]");
    if (!closeEl) return;
    const modal = closeEl.closest("[data-em-vb-modal]");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.hidden = true;
    const player = modal.querySelector("[data-em-vb-player]");
    if (player) player.pause();
  });

  customElements.define("em-product-video-bubble", EmProductVideoBubble);
})();
